import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './polyfills';

import './fonts/Ambit/Ambit-Bold.woff';
import './fonts/Ambit/Ambit-Bold.woff2';
import './fonts/Ambit/Ambit-Regular.woff';
import './fonts/Ambit/Ambit-Regular.woff2';
import './fonts/Ambit/Ambit-SemiBold.woff';
import './fonts/Ambit/Ambit-SemiBold.woff2';
import './fonts/Ambit/Ambit-Thin.woff';
import './fonts/Ambit/Ambit-Thin.woff2';
import 'react-datepicker/dist/react-datepicker.css';

// Listener para receber mensagens do parent frame (cross-origin)
// Usado para detectar quando está sendo executado dentro de um iframe do app React Native (Standalone)
window.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SET_REACT_NATIVE_WEBVIEW') {
    (window as any).ReactNativeWebView = event.data.value;
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
